export const SATISFACTION = {
    SET_SOCIETES: 'SET_SOCIETES',
    SET_SOCIETE_SELECTIONNEE: 'SET_SOCIETE_SELECTIONNEE',
    SET_SATISFACTION: 'SET_SATISFACTION',
};
